import { render, staticRenderFns } from "./CompanyAssignment.vue?vue&type=template&id=c43d1cc0"
import script from "./CompanyAssignment.vue?vue&type=script&lang=js"
export * from "./CompanyAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports